// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "header-239EC";
var _4 = "header__cities-1xgtz";
export { _1 as "__esModule", _2 as "tablet", _3 as "header", _4 as "header__cities" }
export default { "__esModule": _1, "tablet": _2, "header": _3, "header__cities": _4 }
